export default "__VITE_ASSET__B7rwJa5h__"